"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Get = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _equals = require("./utils/equals");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GetError = function GetError(message) {
  _classCallCheck(this, GetError);

  _defineProperty(this, "name", void 0);

  _defineProperty(this, "message", void 0);

  this.name = 'GetError';
  this.message = message || '';
};

GetError.prototype = Error.prototype;

var Get =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Get, _React$Component);

  function Get(props, context) {
    var _this;

    _classCallCheck(this, Get);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Get).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "state", {
      data: null,
      error: null,
      loading: false
    });

    _defineProperty(_assertThisInitialized(_this), "cache", void 0);

    _defineProperty(_assertThisInitialized(_this), "fetch", function () {
      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          loading: true
        });
      });

      var failOnError = _this.props.failOnError;

      var promises = _this.props.requests.map(function (req) {
        return fetch(req.uri, {
          credentials: req.credentials || 'include',
          headers: req.headers || {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          if (response.status !== 200 && !failOnError) {
            return null;
          }

          if (!response.ok) {
            throw new GetError(response.statusText);
          }

          if (response.status < 200 || response.status > 300) {
            throw new GetError(response.statusText);
          }

          if (_this.props.onRequestComplete) {
            _this.props.onRequestComplete(response);
          }

          return response.json();
        });
      });

      return Promise.all(promises).then(function (dataArray) {
        var data = dataArray.length > 1 ? dataArray : dataArray[0];

        _this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            data: data,
            error: null,
            loading: false
          });
        }, function () {
          _this.cache.setItem(_this.props.cacheKey, data);
        });
      }).catch(function (err) {
        if (err.name === 'GetError') {
          _this.setState(function (prevState) {
            return _objectSpread({}, prevState, {
              error: err.message
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cacheDidChange", function (data) {
      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          data: data
        });
      });
    });

    _this.cache = context.cache;
    return _this;
  }

  _createClass(Get, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var data;
      return regeneratorRuntime.async(function componentDidMount$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.cache.subscribe(this.props.cacheKey, this.cacheDidChange);
              data = this.cache.getItem(this.props.cacheKey);

              if (data) {
                this.setState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    data: data
                  });
                });
              }

              this.fetch();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      var notEqual = !(0, _equals.equals)(nextProps.requests.map(function (x) {
        return x.uri;
      }), this.props.requests.map(function (x) {
        return x.uri;
      }));

      if (nextProps.cacheKey !== this.props.cacheKey || notEqual) {
        this.fetch();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cache.unsubscribe(this.cacheDidChange);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state, this.fetch);
    }
  }]);

  return Get;
}(_react.default.Component);

exports.Get = Get;

_defineProperty(Get, "contextTypes", {
  cache: _propTypes.default.object.isRequired
});